module.exports = __webpack_public_path__ + "5c7262935348a4db90c679d403ce4eb2.MP3";